export { default } from './LoadingContent-component';
